<button mat-stroked-button *appRole="['Personas.Eliminar']" color="warn" class="float-right " (click)="openDialog()">
    <mat-icon>delete</mat-icon>
    Eliminar
</button>
